import { FC, ReactNode } from 'react'

import { useSetAtom } from 'jotai'
import {
  Text,
  Button,
  IconXMarkLarge,
  GreyGrey80,
  GreyWhite,
  Primary14SemiBold,
  Flex
} from '@sequencehq/core-components'
import { currentSidebarModeAtom } from 'Automations/automationEditor/atoms'

const SidebarTemplateContainer: FC<{
  children: ReactNode
  'data-testid'?: string
}> = ({ children, 'data-testid': dataTestId }) => {
  return (
    <Flex
      data-testid={dataTestId}
      flexDir="column"
      minWidth="320px"
      minHeight="100%"
    >
      {children}
    </Flex>
  )
}

const Header: FC<{ title: string; 'data-testid'?: string }> = ({
  title,
  'data-testid': dataTestId
}) => {
  const setCurrentSidebarMode = useSetAtom(currentSidebarModeAtom)

  return (
    <Flex
      data-testid={dataTestId}
      padding="16px 20px"
      justifyContent="space-between"
      alignItems="center"
      position="sticky"
      top="0"
      left="0"
      backgroundColor={GreyWhite}
      zIndex="1"
    >
      <Text {...Primary14SemiBold} color={GreyGrey80}>
        {title}
      </Text>

      <Button
        variant="unstyled"
        onClick={() => setCurrentSidebarMode(undefined)}
        style={{ width: '20px', height: '20px', minWidth: 'initial' }}
        data-testid={dataTestId ? `${dataTestId}.close` : undefined}
      >
        <IconXMarkLarge color={GreyGrey80} />
      </Button>
    </Flex>
  )
}

const Content: FC<{ children: ReactNode; gap: string }> = ({
  children,
  gap
}) => {
  return (
    <Flex flexDir="column" padding="0 12px 16px 12px" gap={gap}>
      {children}
    </Flex>
  )
}

const Section: FC<{ children: ReactNode; 'data-testid'?: string }> = ({
  children,
  'data-testid': dataTestId
}) => {
  return (
    <Flex data-testid={dataTestId} flexDir="column" marginX="8px">
      {children}
    </Flex>
  )
}

export const SidebarTemplate = Object.assign(SidebarTemplateContainer, {
  Header,
  Content,
  Section
})
